import classes from 'dom-helpers/class';
import css from 'dom-helpers/style';
import getScrollbarSize from 'dom-helpers/util/scrollbarSize';
import isOverflowing from './utils/isOverflowing';
import { ariaHidden, hideSiblings, showSiblings } from './utils/manageAriaHidden';
function findIndexOf(arr, cb) {
  let idx = -1;
  arr.some((d, i) => {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
    return false;
  });
  return idx;
}
function findContainer(data, modal) {
  return findIndexOf(data, d => d.modals.indexOf(modal) !== -1);
}
function setContainerStyle(state, container) {
  const style = {
    overflow: 'hidden'
  };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };
  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt(css(container, 'paddingRight') || 0, 10) + getScrollbarSize() + 'px';
  }
  css(container, style);
}
function removeContainerStyle(_ref, container) {
  let {
    style
  } = _ref;
  Object.keys(style).forEach(key => {
    container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */
function ModalManager(_temp) {
  let {
    hideSiblingNodes = true,
    handleContainerOverflow = true
  } = _temp === void 0 ? {} : _temp;
  // State maintained in closure
  const modals = [];
  const containers = [];
  const data = [];
  const add = (modal, container, className) => {
    let modalIdx = modals.indexOf(modal);
    const containerIdx = containers.indexOf(container);
    if (modalIdx !== -1) {
      return modalIdx;
    }
    modalIdx = modals.length;
    modals.push(modal);
    if (hideSiblingNodes) {
      hideSiblings(container, modal.modalNode);
    }
    if (containerIdx !== -1) {
      data[containerIdx].modals.push(modal);
      return modalIdx;
    }
    const containerData = {
      modals: [modal],
      // right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],
      overflowing: isOverflowing(container)
    };
    if (handleContainerOverflow) {
      setContainerStyle(containerData, container);
    }
    containerData.classes.forEach(classes.addClass.bind(null, container));
    containers.push(container);
    data.push(containerData);
    return modalIdx;
  };
  const remove = modal => {
    const modalIdx = modals.indexOf(modal);
    if (modalIdx === -1) {
      return;
    }
    const containerIdx = findContainer(data, modal);
    const containerData = data[containerIdx];
    const container = containers[containerIdx];
    containerData.modals.splice(containerData.modals.indexOf(modal), 1);
    modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (containerData.modals.length === 0) {
      containerData.classes.forEach(classes.removeClass.bind(null, container));
      if (handleContainerOverflow) {
        removeContainerStyle(containerData, container);
      }
      if (hideSiblingNodes) {
        showSiblings(container, modal.modalNode);
      }
      containers.splice(containerIdx, 1);
      data.splice(containerIdx, 1);
    } else if (hideSiblingNodes) {
      // otherwise make sure the next top modal is visible to a SR
      ariaHidden(false, containerData.modals[containerData.modals.length - 1].modalNode);
    }
  };
  const isTopModal = modal => !!modals.length && modals[modals.length - 1] === modal;
  return {
    add,
    remove,
    isTopModal
  };
}
export default ModalManager;